import type { VSelectItems } from '../../../../types/vuetify'

export interface FlexDiscountRow {
  id: null | number
  days: null | number
  percentage: null | number
}

export const spotheroFlexDiscountDurations: VSelectItems = [
  {value: 1, title: '>1 day'},
  {value: 2, title: '2+ days'},
  {value: 3, title: '3+ days'},
  {value: 5, title: '5+ days'},
  {value: 7, title: '7+ days'},
  {value: 14, title: '14+ days'},
  {value: 28, title: '28+ days'},
]
